<template>
	<div class="addzz">
		<el-dialog 
			:modal-append-to-body='true'
			width="900px"
			center
			:append-to-body='true'
			:visible.sync="dialogVisible">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					党建带动
					<div class="addline"></div>
				</div>
			</div>
			<div class="databank">
				
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="closeEdit()">取 消</el-button>
			</div>
		</el-dialog>
		<div class="loading">
			
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		props:{
			dialogVisible:{
				type:Boolean,
				default:false
			}
		},
		methods:{
			submit(){
				
			},
			closeEdit(){
				
			}
		}
	}
</script>

<style>
</style>
